module.exports = __webpack_public_path__ + "img/printer-fill.1fe693f8.svg";